import background from './free-spins-bg.webp';
import wheel from './bonanza-wheel.webp';
import lobbyWidgetIcon from './giftbox.webp';

export default {
  background,
  wheel,
  lobbyWidgetIcon,
};
